var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnLarge404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 84,
    viewBox: "0 0 138 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.236 63.84V21.16a1 1 0 0 0-1-1h-.683a1 1 0 0 0-.793.391L5.508 48.241a1 1 0 0 0-.206.608v.841a1 1 0 0 0 1 1h29.462M126.75 63.84V21.16a1 1 0 0 0-1-1h-.683a.999.999 0 0 0-.793.391l-21.252 27.69a1 1 0 0 0-.207.608v.841a1 1 0 0 0 1 1h29.463",
    stroke: "#003A70",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.689 59.984a25.116 25.116 0 0 0 5.585-8.228A25.162 25.162 0 0 0 59.232 42a25.162 25.162 0 0 0-1.958-9.756 25.116 25.116 0 0 0-5.585-8.228M86.89 59.984a25.167 25.167 0 0 1-5.582-8.23 25.213 25.213 0 0 1 0-19.508 25.167 25.167 0 0 1 5.582-8.23",
    stroke: "#003A70",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.29 67.2c13.886 0 25.144-11.282 25.144-25.2S83.176 16.8 69.29 16.8c-13.887 0-25.145 11.282-25.145 25.2S55.403 67.2 69.29 67.2z",
    stroke: "#003A70",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLarge404);
export default __webpack_public_path__ + "static/media/icn_large_404.wtn-site.svg";
export { ForwardRef as ReactComponent };